import { useEffect, useState } from 'react';

import { getPlans } from './items';
import { Plan } from './plan';

import css from './pricing-plans.css';

export const PricingPlans: FC = () => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        <div className={css.pricingPlans}>
            <h1>Тарифы</h1>
            <h2>Тарифные планы</h2>
            <div className={css.plans}>
                {getPlans(mounted).map(({ header, hint, items, price }) => (
                    <Plan header={header} hint={hint} items={items} key={price} price={price} />
                ))}
            </div>
        </div>
    );
};
